module.exports = __webpack_public_path__ + "static/img/shareno.e2f1d8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shareno.png
// module id = jViv
// module chunks = 5